<template>
  <div class="content-430">
    <div class="header-wrapper-430" style="margin-bottom: 8px">
      <Form
        ref="searchForm"
        class="search-wrapper-430"
        :model="formInline"
        :label-width="0"
        inline
      >
        <FormItem label="">
          <ChooseApply
            v-if="portOrg != 2"
            ref="chooseSchoolRef"
            :placeholder="`请选择学校`"
            :year-term-code="[formInline.yearCode, formInline.termCode]"
            :clearable="true"
            :org-type="`1`"
            @on-change="onSchoolChange"
          ></ChooseApply>
          <p v-else>{{ userInfo && userInfo.orgName }}</p>
        </FormItem>
        <FormItem>
          <Input
            v-model="formInline.studentName"
            type="text"
            placeholder="请输入学生姓名"
            clearable
          >
          </Input>
        </FormItem>
        <FormItem>
          <ChooseGradeAndClass
            ref="chooseGradeAndClassRef"
            style="margin-right: 8px"
            :school-id="formInline.schoolId"
            @on-change="onChangeGradeClass"
          ></ChooseGradeAndClass>
        </FormItem>
        <FormItem>
          <Input
            v-model="formInline.signPhoneNo"
            type="text"
            placeholder="请输入家长号码"
            clearable
          >
          </Input>
        </FormItem>
        <FormItem>
          <CascaderYearTerms
            ref="cascaderYearTerms"
            :placeholder="`请选择学期`"
            @on-change="onCascaderChange"
            @on-init="onCascaderInit"
          ></CascaderYearTerms>
        </FormItem>
        <FormItem>
          <ChooseOrg
            v-if="portOrg != 3"
            ref="chooseOrgRef"
            :year-terms="[formInline.yearCode, formInline.termCode]"
          ></ChooseOrg>
          <p v-else>{{ userInfo.orgName }}</p>
        </FormItem>

        <FormItem>
          <Input
            v-model="formInline.classroomName"
            type="text"
            placeholder="请输入课程名称"
            clearable
          >
          </Input>
        </FormItem>
        <Button
          type="primary"
          style="margin-left: 16px"
          @click="handleSearch"
        >查询</Button>
        <Button style="margin-left: 16px" @click="handleReset">重置</Button>
      </Form>
      <div
        class="action-wrap flex justify-content_end"
        style="margin-bottom: 8px"
      >
        <Button
          class="btn-download"
          style="margin-left: 16px"
          type="primary"
          @click="handleDownload"
        >导出</Button>
      </div>
    </div>

    <div class="table-main">
      <Table
        :columns="signingColumns"
        :data="tableList"
        :loading="tableLoading"
        :max-height="tableHeight"
        border
      >
        <template slot="classroomNames" slot-scope="{ row, index }">
          <div class="color-blue cursor-pointer">
            <TablePoptip :content="row.classroomNames"> </TablePoptip>
          </div>
        </template>
        <template slot="signSts" slot-scope="{ row, index }">
          <span v-if="row.signSts == 1" class="color-blue">已签约</span>
          <span v-else>--</span>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <span class="click-btn-430" @click="handleDetails(row)">详情</span>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-sizer
        show-total
        show-elevator
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="onPageSizeChange"
      ></Page>
    </div>
    <ViewPdf ref="viewPdfRef"></ViewPdf>
  </div>
</template>

<script>
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import ChooseOrg from '@c/searchBlock/ChooseOrg.vue';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
import platformApi from '@/request/eduCenter/platform.js';
import { signingColumns } from './assets/index.js';
import ChooseGradeAndClass from '@c/searchBlock/ChooseGradeAndClass.vue';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import ViewPdf from './ViewPdf.vue';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { mapMutations } from 'vuex';
export default {
  name: 'PlatformSigning',
  components: {
    CascaderYearTerms,
    ChooseGradeAndClass,
    ChooseOrg,
    ChooseApply,
    ViewPdf
  },
  mixins: [mixinTableHeight],
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('PlatformSigning');
    next();
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      formInline: {
        studentName: '',
        classroomName: '',
        yearCode: '',
        termCode: '',
        schoolId: '',
        signPhoneNo: '',
        orgId: ''
      },
      signingColumns,
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      tableList: [],
      tableLoading: false,
      portOrg: ''

    };
  },
  activated() {
    this.getServiceSigningList();
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.$nextTick(() => {
      this.formInline.schoolId = this.portOrg === 2 ? this.userInfo.orgId : '';
    });
  },
  mounted() {
    // this.$eventHub.$on('changeSchool', id => {
    //   console.log('eventHubchangeSchool', id);
    //   this.handleChangeSchool(id);
    // });
  },
  // destroyed() {
  //   this.$eventHub.$off('changeSchool');
  // },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    handleReset() {
      for (const k in this.formInline) {
        if (!['schoolId'].includes(k)) {
          this.formInline[k] = '';
        }
      }
      this.$refs.chooseOrgRef && this.$refs.chooseOrgRef.handleClear();
      this.$refs.chooseSchoolRef && this.$refs.chooseSchoolRef.handleClear();
      this.$refs.chooseGradeAndClassRef.handleClear();
      this.$nextTick(() => {
        this.handleSearch();
      });
    },
    onSchoolChange(schInfo) {
      this.formInline.schoolId = schInfo.orgId;
    },
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getServiceSigningList();
    },
    onCascaderInit(val) {
      this.formInline.yearCode = val[0];
      this.formInline.termCode = val[1];
      this.getServiceSigningList();
    },
    onCascaderChange(val) {
      this.formInline.yearCode = val[0];
      this.formInline.termCode = val[1];
      this.$nextTick(() => {
        this.$refs.chooseOrgRef && this.$refs.chooseOrgRef.init();
        this.$refs.chooseSchoolRef && this.$refs.chooseSchoolRef.handleClear();
      });
    },
    onChangeGradeClass(val) {
      // if (val.length == 1) {
      //   this.formInline.gradeId = val[0]
      // } else if (val.length == 2) {
      //   this.formInline.gradeId = val[0]
      //   this.formInline.classId = val[1]
      // } else {
      //   this.formInline.gradeId = ''
      //   this.formInline.classId = ''
      // }

    },
    handleDetails(row) {
      if (!row.signFileId) {
        this.$Message.warning('配置未完成，不支持预览!');
        return null;
      }
      this.$refs.viewPdfRef.handleShow(row);
    },
    handleChangeSchool(id) {
      this.formInline.schoolId = id;
      this.handleSearch();
    },

    getParameter() {
      const yearTerms = this.$refs.cascaderYearTerms.getResult();
      if (yearTerms && yearTerms.length > 1) {
        this.formInline.yearCode = yearTerms[0];
        this.formInline.termCode = yearTerms[1];
      }

      this.formInline.orgId = this.portOrg != 3 ? this.$refs.chooseOrgRef.getOrgId() : this.userInfo.orgId;
      this.formInline.schoolId = this.portOrg != 2 ? this.$refs.chooseSchoolRef.getResult().orgId : this.userInfo.orgId;
      const { schoolId, termCode, yearCode, signPhoneNo, studentName, classroomName, orgId } = this.formInline;
      const gradeClass = this.$refs.chooseGradeAndClassRef.getSelectedData();
      let gradeName = ''; let className = '';
      if (gradeClass.length == 1) {
        gradeName = gradeClass[0]['label'];
      } else if (gradeClass.length == 2) {
        gradeName = gradeClass[0]['label'];
        className = gradeClass[1]['label'];
      } else {

      }

      return {
        schoolId,
        termCode,
        yearCode,
        gradeName,
        className,
        signPhoneNo,
        studentName,
        classroomName,
        orgId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
    },
    // 导出
    async studentServiceSigningAgreementExport() {
      const parameter = this.getParameter();
      delete parameter.pageNum;
      delete parameter.pageSize;
      this.$Spin.show();
      const res = await platformApi.studentServiceSigningAgreementExport(parameter);

      this.$Spin.hide();
      downLoadByBlob(res);
    },
    // 获取列表
    async getServiceSigningList() {
      const parameter = this.getParameter();
      this.tableLoading = true;
      const res = await platformApi.getServiceSigningList(parameter);
      this.tableLoading = false;
      if (res.status == 200) {
        this.tableList = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    handleDownload() {
      this.studentServiceSigningAgreementExport();
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getServiceSigningList();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getServiceSigningList();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
